import React from 'react';
import { IconButton as BaseIconButton } from '@material-ui/core/';
import PropTypes from 'prop-types';

const IconButton = (props) => {
  return (
    <BaseIconButton
      className={props.className}
      classes={props.classes}
      color={props.color}
      disabled={props.disabled}
      onClick={props.onClick}
    >
      {props.children}
    </BaseIconButton>
  );
};

IconButton.defaultProps = {
  size: 'medium',
  color: 'default',
  disable: false,
};

IconButton.propTypes = {
  classes: PropTypes.object,
  size: PropTypes.oneOf(['small', 'medium']),
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),
  disabled: PropTypes.bool,
  children: PropTypes.node,
};

export default IconButton;
